export default {
  namespaced: true,
  modules: {
    categories: require("./categories").default,
    channels: require("./channels").default,
    hooks: require("./hooks").default,
    mappings: require("./mappings").default,
    optOuts: require("./optOuts").default,
    recipientTypes: require("./recipientTypes").default,
    rules: require("./rules").default,
    topics: require("./topics").default
  }
};
